import React from 'react';

import "./HeadPane.scss";



export const HeadPane = (props) => {
    const { } = props;

    return (
        <nav className="HeadPane">
            <section>

            </section>
        </nav>
    )
}

